import { useEffect, useState } from 'react';

import { useUIContext } from 'lib/context/UIContext/UIContext';
import { ia } from 'lib/helpers/utility';

import TableRowDesktop from './TableRowDesktop';
import TableRowMobile from './TableRowMobile';

const TableRow = ({
  columnDefs,
  row,
  idx,
  depth = 1,
  className,
  style,
  cellClassName,
  cellStyle,
  preview,
  CustomRowHeader,
  small = false,
  variant,
  expanded = false
}) => {
  const [isExpanded, setIsExpanded] = useState(expanded);
  const { device } = useUIContext();
  const isMobile = device === 'tablet-sm' || device === 'mobile';

  const handleExpand = () => setIsExpanded((prev) => !prev);

  useEffect(() => {
    if (!row.is_detailed) {
      setIsExpanded(false);
    }
  }, [row.is_detailed]);

  return (
    <>
      {CustomRowHeader && (
        <tr>
          <th colSpan={!isMobile ? columnDefs.length : 1}>
            <CustomRowHeader row={row} />
          </th>
        </tr>
      )}
      <TableRowDesktop
        columnDefs={columnDefs}
        row={row}
        idx={idx}
        className={className}
        style={style}
        cellClassName={cellClassName}
        cellStyle={cellStyle}
        isExpanded={isExpanded}
        handleExpand={handleExpand}
        small={small}
        preview={preview}
      />

      <TableRowMobile
        columnDefs={columnDefs}
        row={row}
        idx={idx}
        isExpanded={isExpanded}
        handleExpand={handleExpand}
        className={className}
        CustomRowHeader={CustomRowHeader}
      />

      {ia(row.children) &&
        isExpanded &&
        row.children.map((childRow, childIdx) => (
          <TableRow
            key={childRow.id || `${idx}-${childIdx}`}
            columnDefs={columnDefs}
            row={childRow}
            idx={childIdx}
            depth={depth}
            small={small}
            className={variant === 'primary' ? 'bg-primary-100' : 'bg-neutral-50'}
          />
        ))}
    </>
  );
};

export default TableRow;
